import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";
import Candidate from "../../layouts/Candidate";
import { useParams, useLocation } from "react-router-dom";
import Axios from "axios";
import axios from "../../services/axios";
import url from "../../services/url";
import { If, Else } from "react-condition";
import GetFormComponent from "./GetFormComponent";
import PersonalDetails from "./ApplicationView.PersonalDetails";
import slugify from "slugify";
import uploadSizes from "../../services/uploadSizes";
import $ from "jquery";
import cx from "classnames";
import swal from "sweetalert";
import { withRouter } from "react-router";
import NavbarApplication from "../../components/NavbarApplication";
import ReactLoading from "react-loading";
import rawdata from "../../raw";
import isConsultant from "../../services/isConsultant";
import { IMAGE_SIZE, DOC_SIZE, VIDEO_SIZE, DOMAIN } from "../../umConfig";
import { Select, Skeleton, Space } from "antd";
import { STATE_AND_CITIES } from "../../utils/StateAndCities";
import Img from "../../images/kocharlogo.png";
import IGZY from "../../images/igzy.png";
import KOCHARSOFT from "../../images/kocharsoft.svg";
import MAXICUS from "../../images/maxicus_concent.svg";
import useAxios from "../../hooks/useAxios";
import useAuthUserToken from "../../hooks/useAuthUserToken";
import CceFormSubmitButton from "./components/CceFormSubmitButton";
import OtherSubmitButton from "./components/OtherSubmitButton";
const { Option } = Select;

// Convert base64 to File object
function base64ToFile(
  base64String,
  filename,
  mimeType = "application/octet-stream"
) {
  if (!base64String) return null;

  const base64Data = base64String.replace(/^data:[^;]+;base64,/, "");

  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);

  return new File([byteArray], filename, { type: mimeType });
}

const AGENT_APPLICATION_ID = "61d41ac7cc03506243d626f9"

function ApplicationView() {
  const location = useLocation();
  const api = useAxios();
  const { userToken } = useAuthUserToken();
  const searchParams = new URLSearchParams(location.search);
  const walkInType = searchParams.get("walkInType" || "");
  const mobileNum = searchParams.get("mobileno" || "");
  const source = searchParams.get("source" || "");
  const formName = searchParams.get("formname" || "");
  const referalCode = searchParams.get("refcode", "");
  const consultancyName = searchParams.get("consultant_name" || "");
  const utm_medium = searchParams.get("utm_medium", "");
  const utm_campaign = searchParams.get("utm_campaign", "");
  const utm_term = searchParams.get("utm_term", "");
  const candidateId = searchParams.get("candidateid", "");
  const client = searchParams.get("client", "");
  //Decode the MobileNumber
  var decodedNum = mobileNum;
  var decodedSource = source;
  const [mandateFields, setMandateFields] = useState([]);
  const [unmandateFields, setUnMandateFields] = useState([]);
  const [step, setStep] = useState(
    localStorage.getItem("form-step")
      ? Number(localStorage.getItem("form-step"))
      : 1
  );
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [load, setLoad] = useState(false);
  // Uncommon Hooks
  const { id } = useParams();
  localStorage.setItem("form_id", id);
  // States
  const [form, setForm] = useState({
    name: "Loading form...",
    elements: [],
    candidatePhoto: false,
    candidateVideo: false,
    resume: false,
    trf: {
      title: "Loading form...",
      overview: "Please wait a moment for this to load.",
    },
  });

  const [departments, setDepartments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const [agreed, setAgreed] = useState(false);

  // add validation just below the input box
  const [otpStatus, setOtpStatus] = useState("");
  const [errorInputs, setErrorInputs] = useState([]);

  async function fetchConsultantName() {
    try {
      const res = await api.get(`/consultant/ConsultantName`);
      return res.data;
    } catch (err) {
      console.log(err);
      return err;
    }
  }

  // Effects
  useEffect(() => {
    const init = async () => {
      try {
        setIsLoading(true);
        setName(localStorage.getItem("Name"));
        setEmail(localStorage.getItem("Email"));
        const [form, consultantNames] = await Promise.all([
          LoadFormTemplate(),
          fetchConsultantName(),
          getDepartment()
        ]);
        if (
          id === "63be60ffa416b72e38dc2f95" ||
          id === "63caa2a8d703dd1511734625" ||
          id === "66fead70fda16a001307f6c9" ||
          form.formType === "Feedback_Form"
        ) {
          if (candidateId) {
            checkFeedBackStatus();
          } else if (userToken) {
            // Admin/HR template preview - do nothing and load the form template
          } else {
            window.location.replace("/error/Invalid Candidate ID");
          }
        }
        if (mobileNum) {
          for (let key of form?.elements) {
            if (key.properties.label === "How did you come to know about us") {
              if (decodedSource) {
                const result = key?.properties?.options
                  ?.map((name) => name.trim().toLowerCase())
                  .includes(decodedSource.trim().toLowerCase());
                !result && window.location.replace("/error/Invalid Url");
              }
              if (consultancyName) {
                const result = consultantNames
                  ?.map((name) => name.trim().toLowerCase())
                  .includes(consultancyName.trim().toLowerCase());
                !result && window.location.replace("/error/Invalid Url");
              }
            }
          }
          await checkAuthentication();
        } else {
          setOtpStatus("User Authorized");
        }
        validateSamparkRefData();
      } catch (err) {
        console.log(err);
      } finally {
        setIsLoading(false);
      }
    };
    init();
  }, [id, candidateId]);

  const validateSamparkRefData = () => {
    if (referalCode && !client) {
      window.location.replace("/invalidUrl");
    } else if (!referalCode && client) {
      window.location.replace("/invalidUrl");
    } else if (referalCode === "" && client === "") {
      window.location.replace("/invalidUrl");
    }
  };

  const LoadFormTemplate = async () => {
    try {
      const res = await api.get(`/formtemplate/${id}`);
      let unfilterData = res.data;
      const results = filterChildElements(res.data.elements);
      res.data.elements = [...PersonalDetails.elements, ...results];
      setForm(res.data);
      setMandateFields((prevs) => {
        return [
          ...res.data.elements.filter(
            (ele) => ele.properties.required === true
          ),
        ];
      });
      setUnMandateFields((prevs) => {
        return [
          ...res.data.elements.filter(
            (ele) => ele.properties.required === false
          ),
        ];
      });
      return unfilterData;
    } catch (err) {
      console.log(err);
      return err;
    }
  };

  const getDepartment = async () => {
    try {
      const { data } = await api.get(`/trfdepartment`, {
        tokenType: "user",
      });

      const { trfDepartment } = data;
      setDepartments(trfDepartment.filter((e) => e.status));
    } catch (err) {
      console.error(err);
    }
  };

  //Remove child from main array -Lovejot(06-DEC-2022)
  const filterChildElements = (elementsArray) => {
    let arrr = [];

    for (let item of elementsArray) {
      if (item === null) {
        continue;
      } else {
        if (item?.type === "select" || item?.type === "radio") {
          for (let i = 0; i < item?.parent?.length; i++) {
            arrr.push(item?.parent[i]?.child?.id);
          }
        }
      }
    }

    const results = elementsArray.filter(
      (ele) => ele != null && !arrr.some((index) => index === ele.id)
    );

    return results;
  };

  const checkFeedBackStatus = () => {
    Axios.get(
      url(
        `/candidateFeedBack/isFeedBackExist/${candidateId}/form/${form._id || id
        }`
      ),
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      }
    )
      .then((res) => {
        if (res.data.feedBackList === 0) {
          LoadFormTemplate();
        } else {
          window.location.replace("/feedback/already-submitted");
        }
      })
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    function buildAccordions() {
      $(".form-builder-element:not(.heading)").addClass("hidden");
      $(".form-builder-element.heading .btn").on("click", function () {
        $(".form-builder-element:not(.heading)").addClass("hidden");
        let currentElements = $(this)
          .parent()
          .nextUntil(".form-builder-element.heading");
        currentElements.toggleClass("hidden");
      });
      setTimeout(openOnlyFirstAccordion, 100);
      setTimeout(addDividersBeforeHeadings, 150);
    }
    if (form.name !== "Loading form...") {
      //setTimeout(buildAccordions, 100);
    }
  }, [form]);

  // Events
  function openOnlyFirstAccordion() {
    $(".form-builder-element.heading:nth-child(1) .btn").click();
  }

  function addDividersBeforeHeadings() {
    let headings = $("#candidateForm .form-builder-element.heading").slice(1);
    $(
      `<div className="form-builder-element divider"><hr /></div>`
    ).insertBefore(headings);
  }

  const validateInputFields = () => {
    let formData = [];
    let currentError = "";
    setError("");

    let error = [];
    setErrorInputs(error);

    document.querySelectorAll(".form-view").forEach((input) => {
      let element = JSON.parse(input.getAttribute("data"));
      let data = {};
      let supplement = true;

      if (element !== null) {
        // Input Generation
        if (element.type === "texttable") {
          let testData = formData.filter((d) => {
            return d.label === input.getAttribute("label");
          });
          if (testData.length >= 1) {
            supplement = false;
          } else {
            let value = {};
            document
              .querySelectorAll(
                "[name='" + slugify(element.properties.label) + "']"
              )
              .forEach((textfield) => {
                let row = textfield.getAttribute("row");
                let column = textfield.getAttribute("column");
                if (value[row] === null || value[row] === undefined) {
                  value[row] = {};
                  value[row][column] = textfield.value;
                } else {
                  value[row][column] = textfield.value;
                }
              });
            data = {
              label: input.getAttribute("label"),
              value: JSON.stringify(value),
              element,
            };
          }
        } else if (element.type === "checkbox") {
          let testData = formData.filter((d) => {
            return d.label === input.getAttribute("label");
          });
          if (testData.length >= 1) {
            supplement = false;
          } else {
            let value = [];
            document
              .querySelectorAll(
                "[name='" + slugify(element.properties.label) + "']:checked"
              )
              .forEach((checkbox) => {
                if (checkbox.checked) {
                  value.push(checkbox.getAttribute("value"));
                }
              });
            data = {
              label: input.getAttribute("label"),
              value,
              element,
            };
          }
        } else if (element.type === "radio") {
          let testData = formData.filter((d) => {
            return d.label === input.getAttribute("label");
          });
          if (testData.length >= 1) {
            supplement = false;
          } else {
            let radio = document.querySelector(
              "[name='" + slugify(element.properties.label) + "']:checked"
            );
            let value = null;
            if (radio !== null) {
              value = radio.value;
            }
            data = {
              label: input.getAttribute("label"),
              value,
              element,
            };
          }
        } else if (element.type === "multiSelect") {
          data = {
            label: input.getAttribute("label"),
            value: element.properties.value,
            element,
          };
        } else if (element.type === "datetime") {
          data = {
            label: input.getAttribute("label"),
            value: element.properties.value,
            element,
          };
        } else if (element.type === "capturephoto") {
          const elementWithoutValue = JSON.parse(JSON.stringify(element));
          delete elementWithoutValue.value;
          const file = base64ToFile(
            element?.value?.src || "",
            element?.value?.name,
            "image/png"
          );
          data = {
            label: element?.properties?.label,
            value: element?.value?.name,
            file: file,
            element: elementWithoutValue,
          };
        } else if (element.type === "statecity") {
          data = {
            label: "statecity",
            valueOfField: [
              {
                label: "Select State",
                value: element?.value?.state || "",
                element,
              },
              {
                label: "Select City",
                value: element?.value?.city || "",
                element,
              },
            ],
            element,
          };
        } else if (element.type === "departmentdesignation") {
          const { value, ...rest } = element
          data = {
            label: "departmentdesignation",
            valueOfField: [
              {
                label: "Select Department",
                value: element?.value?.departmentText || "",
                element: rest,
                _id: element?.value?.department || "",
              },
              {
                label: "Select Designation",
                value: element?.value?.designationText || "",
                element: rest,
                _id: element?.value?.designation || ""
              },
            ],
            element: rest,
          };
        } else {
          if (input instanceof HTMLDivElement) {
            data = {
              label: input.getAttribute("label"),
              value: input.getAttribute("value"),
              element,
            };
          } else {
            data = {
              label: input.getAttribute("label"),
              value: input.value,
              element,
            };
          }
        }

        // Input Validation
        if (supplement) {
          //Dynamic validations for alphabets -Lovejot(12-DEC-2022)

          if (element?.type === "capturephoto") {
            if (data.element.properties.required === true && !userToken) {
              if (!data.value) {
                currentError = `${data.element.properties.label} is required field.`;
                error.push({
                  label: data.element.properties.label,
                  value: `${data.element.properties.label} is required field.`,
                });
              }
            }
          }

          if (element.type === "statecity") {
            let checkCity = false;
            for (let i = 0; i < data?.valueOfField?.length; i++) {
              if (data?.valueOfField[i]?.element.properties.required === true) {
                if (data?.valueOfField[i].value === "") {
                  currentError = `State and City is required field.`;
                  error.push({
                    label: data?.valueOfField[i].label,
                    value: `State and City is required field.`,
                  });
                }
              } else {
                if (
                  data?.valueOfField[i].label.toLowerCase().trim() ===
                  "select state"
                ) {
                  if (data?.valueOfField[i].value !== "") {
                    checkCity = true;
                  }
                }
                if (checkCity) {
                  if (
                    data?.valueOfField[i].label.toLowerCase().trim() ===
                    "select city"
                  ) {
                    if (data?.valueOfField[i].value === "") {
                      currentError = `City is required field.`;
                      error.push({
                        label: data?.valueOfField[i].label,
                        value: `City is required field.`,
                      });
                    }
                  }
                }
              }
            }
          }

          if (element.type === "departmentdesignation") {
            let checkDesignation = false;
            for (let i = 0; i < data?.valueOfField?.length; i++) {
              console.log(data?.valueOfField[i], "HHHHHHHHHH")
              if (data?.valueOfField[i]?.element.properties.required === true) {
                if (data?.valueOfField[i].value === "") {
                  currentError = `Department and Designation is required field.`;
                  error.push({
                    label: data?.valueOfField[i].label,
                    value: `Department and Designation is required field.`,
                  });
                }
              } else {
                if (
                  data?.valueOfField[i].label.toLowerCase().trim() ===
                  "select department"
                ) {
                  if (data?.valueOfField[i].value !== "") {
                    checkDesignation = true;
                  }
                }
                if (checkDesignation) {
                  if (
                    data?.valueOfField[i].label.toLowerCase().trim() ===
                    "select designation"
                  ) {
                    if (data?.valueOfField[i].value === "") {
                      currentError = `Designation is required field.`;
                      error.push({
                        label: data?.valueOfField[i].label,
                        value: `Designation is required field.`,
                      });
                    }
                  }
                }
              }
            }
          }

          if (element.properties !== null) {
            if (typeof data.value === "string") {
              let alphabets = /^[-a-zA-Z][-a-zA-Z ]*$/;
              if (data.element.isAlpha === true && data.value.length !== 0) {
                if (!data.value.trim().match(alphabets)) {
                  currentError = `Only alphabets are allowed in ${data.label}`;
                  error.push({
                    label: data.label,
                    value: `Only alphabets are allowed in ${data.label}`,
                  });
                }
              }
              //Dynamic validations for Numbers -Lovejot(12-DEC-2022)
              let isnum = /^\d+$/;
              if (data.element.isNumber === true && data.value.length !== 0) {
                if (!isnum.test(data.value)) {
                  currentError = `Only Numbers are allowed in ${data.label}`;
                  error.push({
                    label: data.label,
                    value: `Only Numbers are allowed in ${data.label}`,
                  });
                }
              }

              //Dynamic Length validations for Numbers -Lovejot(12-DEC-2022)
              if (
                data.element.type === "text" ||
                data.element.type === "textarea" ||
                data.element.type === "number"
              ) {
                if (data.value.length !== 0) {
                  if (
                    data.element.properties.minLengthValidation !== undefined &&
                    data.element.properties.maxLengthValidation !== undefined
                  ) {
                    if (
                      data.value.trim().length >=
                      parseInt(data.element.properties.minLengthValidation) &&
                      data.value.trim().length <=
                      parseInt(data.element.properties.maxLengthValidation)
                    ) {
                    } else {
                      error.push({
                        label: data.label,
                        value: `Min length ${data.element.properties.minLengthValidation} and Max length ${data.element.properties.maxLengthValidation} are allowed in ${data.label}`,
                      });
                      currentError = `Min length ${data.element.properties.minLengthValidation} and Max length ${data.element.properties.maxLengthValidation} are allowed in ${data.label}`;
                    }
                  }
                }
              }
              // email validation
              const emailPattern = new RegExp(
                /^\w+([\.-com]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
              );
              if (data.label.trim() === "Email" && data.value.trim() === "") {
                currentError =
                  "'" + element.properties.label + "' is a required question.";
                error.push({
                  label: element.properties.label,
                  value: element.properties.label + " is a required question.",
                });
              } else if (
                data.label === "Email" &&
                !emailPattern.test(data.value)
              ) {
                currentError =
                  "Invalid email id format, Please fill correct email id";
                error.push({
                  label: element.properties.label,
                  value:
                    "Invalid email id format, Please fill correct email id",
                });
              }

              // Validate Date of birth
              if (data.label === "Date of Birth") {
                var date = data.value.split("-");

                // Date of Age should be between 18-40 years

                var daterange = data.value;

                var today = new Date();
                var birthDate = new Date(daterange);
                var age = today.getFullYear() - birthDate.getFullYear();
                var m = today.getMonth() - birthDate.getMonth();
                if (
                  m < 0 ||
                  (m === 0 && today.getDate() < birthDate.getDate())
                ) {
                  age--;
                }
                if (age <= 17) {
                  currentError = "Age should not smaller than 18 year";
                  error.push({
                    label: element.properties.label,
                    value: "Age should not smaller than 18 year",
                  });
                } else if (age > 55) {
                  currentError = "Age should not greater than 55 year";
                  error.push({
                    label: element.properties.label,
                    value: "Age should not greater than 55 year",
                  });
                }
              }
              if (data.label === "Date of Birth" && data.value.trim() === "") {
                currentError =
                  "'" + element.properties.label + "' is a required field.";
                error.push({
                  label: element.properties.label,
                  value: element.properties.label + " is a required field.",
                });
              } else if (data.label === "Date of Birth") {
                if (date[0] < 1000 || date[0].length > 4) {
                  currentError = "Please enter valid date of birth";
                  error.push({
                    label: element.properties.label,
                    value: "Please enter valid date of birth",
                  });
                }
              }
            }
          }

          if (element.properties !== null) {
            // Validate Required Inputs
            if (element.properties.required !== null) {
              if (element.properties.required === true) {
                // Validate Stringed Inputs
                if (typeof data.value === "string") {
                  //Regular expression for validation
                  if (data.label === "Date of Birth") {
                    var date = data.value.split("-");

                    // Date of Age should be between 18-40 years

                    var daterange = data.value;

                    var today = new Date();
                    var birthDate = new Date(daterange);
                    var age = today.getFullYear() - birthDate.getFullYear();
                    var m = today.getMonth() - birthDate.getMonth();
                    if (
                      m < 0 ||
                      (m === 0 && today.getDate() < birthDate.getDate())
                    ) {
                      age--;
                    }
                    if (age <= 17) {
                      currentError = "Age should not smaller than 18 year";
                      error.push({
                        label: element.properties.label,
                        value: "Age should not smaller than 18 year",
                      });
                    } else if (age > 55) {
                      currentError = "Age should not greater than 55 year";
                      error.push({
                        label: element.properties.label,
                        value: "Age should not greater than 55 year",
                      });
                    }
                  }
                  var nameRegex = new RegExp(/[^A-Z -]/gi);
                  var languagePattern = new RegExp(/[^A-Z -,]/gi);
                  var pattern = new RegExp(/^[0-9\b]+$/);
                  var emailPattern = new RegExp(
                    /^\w+([\.-com]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
                  );
                  // regex for email:- /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/

                  // test error here
                  if (data.value.trim() === "") {
                    if (data.label === "Name" && data.value.trim() === "") {
                      error.push({
                        label: element.properties.label,
                        value:
                          element.properties.label + " is a required question.",
                      });
                    }
                  }

                  //Phone Number Validation
                  if (
                    data.label === "Phone Number" &&
                    data.value.length !== 10
                  ) {
                    error.push({
                      label: element.properties.label,
                      value:
                        "Invalid mobile format. Please enter only 10-digit mobile number.",
                    });
                  } else if (
                    data.label === "Phone Number" &&
                    !pattern.test(data.value)
                  ) {
                    error.push({
                      label: element.properties.label,
                      value: "Please enter only 10-digit mobile number.",
                    });
                  }

                  //Dynamic validations for alphabets -Lovejot(12-DEC-2022)
                  let alphabets = /^[-a-zA-Z][-a-zA-Z ]*$/;
                  if (
                    data.element.isAlpha === true &&
                    data.value.length !== 0
                  ) {
                    if (!data.value.trim().match(alphabets)) {
                      currentError = `Only alphabets are allowed in ${data.label}`;
                      error.push({
                        label: element.properties.label,
                        value:
                          "Only alphabets are allowed in " +
                          element.properties.label,
                      });
                    }
                  }

                  //Dynamic validations for Numbers -Lovejot(12-DEC-2022)
                  let isnum = /^\d+$/;
                  if (
                    data.element.isNumber === true &&
                    data.value.length !== 0
                  ) {
                    if (!isnum.test(data.value)) {
                      currentError = `Only Numbers are allowed in ${data.label}`;
                      error.push({
                        label: element.properties.label,
                        value:
                          "Only Numbers are allowed in " +
                          element.properties.label,
                      });
                    }
                  }

                  //Dynamic Length validations for Numbers -Lovejot(12-DEC-2022)
                  if (
                    data.element.type === "text" ||
                    data.element.type === "textarea" ||
                    data.element.type === "number"
                  ) {
                    if (
                      data.element.properties.minLengthValidation !==
                      undefined &&
                      data.element.properties.maxLengthValidation !== undefined
                    ) {
                      if (
                        data.value.trim().length >=
                        parseInt(
                          data.element.properties.minLengthValidation
                        ) &&
                        data.value.trim().length <=
                        parseInt(data.element.properties.maxLengthValidation)
                      ) {
                      } else {
                        currentError = `Min length ${data.element.properties.minLengthValidation} and Max length ${data.element.properties.maxLengthValidation} are allowed in ${data.label}`;
                        error.push({
                          label: data.label,
                          value: `Min length ${data.element.properties.minLengthValidation} and Max length ${data.element.properties.minLengthValidation} are allowed in ${data.label}`,
                        });
                      }
                    }
                  }

                  //Aadhar Number Validation
                  if (
                    data.label === "Aadhar Number" &&
                    data.value.length !== 12
                  ) {
                    error.push({
                      label: element.properties.label,
                      value:
                        "Invalid Aadhar format. Please enter only 12-digit aadhar number.",
                    });
                  } else if (
                    data.label === "Aadhar Number" &&
                    !pattern.test(data.value)
                  ) {
                    error.push({
                      label: element.properties.label,
                      value: "Please enter only 12-digit aadhar number.",
                    });
                  }

                  // Validate Address
                  if (data.label === "Address" && data.value.trim() === "") {
                    error.push({
                      label: element.properties.label,
                      value: element.properties.label + " is a required field.",
                    });
                  } else if (
                    data.label === "Address" &&
                    data.value.length >= 400
                  ) {
                    error.push({
                      label: element.properties.label,
                      value: "Address should not more than 400 character",
                    });
                  }
                  // email validation
                  if (data.label === "Email" && data.value.trim() === "") {
                    error.push({
                      label: element.properties.label,
                      value: element.properties.label + " is a required field.",
                    });
                  } else if (
                    data.label === "Email" &&
                    !emailPattern.test(data.value)
                  ) {
                    error.push({
                      label: element.properties.label,
                      value:
                        "Invalid email id format, Please fill correct email id",
                    });
                  }

                  // Validate Date of birth
                  if (
                    data.label === "Date of Birth" &&
                    data.value.trim() === ""
                  ) {
                    error.push({
                      label: element.properties.label,
                      value: element.properties.label + " is a required field.",
                    });
                  } else if (data.label === "Date of Birth") {
                    if (date[0] < 1000 || date[0].length > 4) {
                      error.push({
                        label: element.properties.label,
                        value: "Please enter valid date of birth",
                      });
                    }
                  }

                  // Validation on languages
                  if (
                    data.label === "Indian Languages" &&
                    data.value.trim() === ""
                  ) {
                    error.push({
                      label: element.properties.label,
                      value: element.properties.label + " is a required field.",
                    });
                  } else if (
                    data.label === "Indian Languages" &&
                    languagePattern.test(data.value)
                  ) {
                    error.push({
                      label: element.properties.label,
                      value:
                        "Please enter correct languages, seperate by comma.",
                    });
                  }

                  // proper validation on the bottom of page

                  if (
                    (data.value === null || data.value?.length === 0) &&
                    data.element.type !== "capturephoto" &&
                    data.element.type !== "file" &&
                    data.element.type !== "statecity" &&
                    data.element.type !== "departmentdesignation"
                  ) {
                    if (
                      data.value.trim() === "" ||
                      data.value.trim() === "null"
                    ) {
                      currentError =
                        "'" +
                        element.properties.label +
                        "' is a required question. Please fill it before submission.";
                      error.push({
                        label: element.properties.label,
                        value:
                          element.properties.label +
                          " is a required question. Please fill it before submission.",
                      });
                    } else if (
                      data.label === "Phone Number" &&
                      data.value.length !== 10
                    ) {
                      currentError =
                        "Invalid mobile format. Please enter only 10-digit mobile number.";
                      error.push({
                        label: element.properties.label,
                        value:
                          "Invalid mobile format. Please enter only 10-digit mobile number.",
                      });
                    } else if (
                      data.label === "Phone Number" &&
                      !pattern.test(data.value)
                    ) {
                      currentError =
                        "Please enter only 10-digit mobile number.";
                      error.push({
                        label: element.properties.label,
                        value: "Please enter only 10-digit mobile number.",
                      });
                    } else if (
                      data.label === "Name" &&
                      data.value.length >= 40
                    ) {
                      currentError = "Name should not more than 40 character";
                      error.push({
                        label: element.properties.label,
                        value: "Name should not more than 40 character",
                      });
                    } else if (
                      data.label === "Address" &&
                      data.value.length >= 400
                    ) {
                      currentError =
                        "Address should not more than 400 character";
                      error.push({
                        label: element.properties.label,
                        value: "Address should not more than 400 character",
                      });
                    } else if (
                      data.label === "Email" &&
                      !emailPattern.test(data.value)
                    ) {
                      currentError = "Invalid email id format";
                      error.push({
                        label: element.properties.label,
                        value:
                          "Invalid email id format, Please fill correct email id",
                      });
                    } else if (data.label === "Date of Birth") {
                      if (date[0] < 1000 || date[0].length > 4) {
                        currentError = "Please enter valid date of birth";
                        error.push({
                          label: element.properties.label,
                          value: "Please enter valid date of birth",
                        });
                      }
                    }
                  }
                }
                // Validate Non-Stringed Inputs

                if (
                  (!data.value || data.value?.length === 0) &&
                  data.element.type !== "capturephoto" &&
                  data.element.type !== "file" &&
                  data.element.type !== "statecity" &&
                  data.element.type !== "departmentdesignation"
                ) {
                  currentError =
                    "'" +
                    element.properties.label +
                    "' is a required question. Please fill it before submission.";
                  error.push({
                    label: element.properties.label,
                    value:
                      element.properties.label +
                      " is a required question. Please fill it before submission.",
                  });
                }
              } else if (element.properties.required === false) {
                if (typeof data.value === "string") {
                  //Regular expression for validation
                  if (data.label === "Date of Birth") {
                    var date = data.value.split("-");

                    // Date of Age should be between 18-40 years

                    var daterange = data.value;

                    var today = new Date();
                    var birthDate = new Date(daterange);
                    var age = today.getFullYear() - birthDate.getFullYear();
                    var m = today.getMonth() - birthDate.getMonth();
                    if (
                      m < 0 ||
                      (m === 0 && today.getDate() < birthDate.getDate())
                    ) {
                      age--;
                    }
                    if (age <= 17) {
                      currentError = "Age should not smaller than 18 year";
                      error.push({
                        label: element.properties.label,
                        value: "Age should not smaller than 18 year",
                      });
                    } else if (age > 55) {
                      currentError = "Age should not greater than 55 year";
                      error.push({
                        label: element.properties.label,
                        value: "Age should not greater than 55 year",
                      });
                    }
                  }
                }
              }
            }
            // Validate with Browser Validity
            try {
              if (input.checkValidity() === false) {
                currentError =
                  "'" +
                  element.properties.label +
                  "' contains an invalid answer. " +
                  input.validationMessage;
                error.push({
                  label: element.properties.label,
                  value: input.validationMessage,
                });
              }
            } catch (e) { }
          }
        }
      }
      if (supplement && data !== null && JSON.stringify(data) !== "{}") {
        if (data?.valueOfField && Array.isArray(data.valueOfField)) {
          formData = [...formData, ...data.valueOfField];
        } else {
          formData.push(data);
        }
      }
    });

    return { formData, currentError, error };
  };

  const updateFormData = (payload) => {
    setLoad(true);
    Axios.patch(
      url(`/candidate/completeRegistration/${localStorage.getItem("ids")}`),
      payload,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      }
    )
      .then((result) => {
        setLoad(false);
        localStorage.removeItem("form-step");
        window.location.replace("/Application-submitted/" + formName);
      })
      .catch((error) => {
        if (error.response.data.error.name === "MongoError") {
          setError("Email is already in use. Please use another email.");
        } else if (error.response.data.error === "Mobile No already Exist") {
          setError(
            "Mobile number is already in use. Please use another mobile number."
          );
        } else {
          // alert(error.message)
          // swal(error.message);
          setError(error.response.data.error);
          // console.error(error.response);
          // console.log("error mew", error)
          // alert(error.response.data.error)
        }
        setLoad(false);
      });
  };

  const submitForm = (payload) => {
    setLoad(true);
    Axios.post(url("/candidate"), payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user.token")}`,
      },
    })
      .then((result) => {
        setLoad(false);
        localStorage.setItem("ids", result.data.id);

        // const candidateId = result.data.id;
        // if (id === "631b298327644e09a434926a") {
        //   window.location.replace(
        //     "/optional/test/form/" + id + "/candidate/" + candidateId
        //   );
        //   window.location.replace("/Application-submitted/" + formName);
        // } else if (id === "61d41ac7cc03506243d626f9") {
        //   window.location.replace(
        //     "/instruction/" + id + "/" + candidateId
        //   );
        // } else {
        if (id === AGENT_APPLICATION_ID && !userToken) {
          localStorage.setItem("form-step", 2);
          setAgreed(false);
          setStep(2);
        } else {
          window.location.replace("/Application-submitted/" + formName);
        }
        // }
      })
      .catch((error) => {
        if (error.response.data.error.name === "MongoError") {
          setError("Email is already in use. Please use another email.");
        } else if (error.response.data.error === "Mobile No already Exist") {
          setError(
            "Mobile number is already in use. Please use another mobile number."
          );
        } else {
          // alert(error.message)
          // swal(error.message);
          setError(error.response.data.error);
          // console.error(error.response);
          // console.log("error mew", error)
          // alert(error.response.data.error)
        }
        setLoad(false);
      });
  };

  const finalFeedbackStatus = (payload) => {
    Axios.get(
      url(
        `/candidateFeedBack/isFeedBackExist/${candidateId}/form/${form._id || id
        }`
      ),
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      }
    )
      .then((res) => {
        if (res.data.feedBackList === 0) {
          submitFeedBack(payload);
        } else {
          window.location.replace("/feedback/already-submitted");
        }
      })
      .catch((err) => console.error(err));
  };

  const submitFeedBack = (payload) => {
    Axios.post(url("/candidateFeedBack"), payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user.token")}`,
      },
    })
      .then((result) => {
        setLoad(false);
        window.location.replace("/submit/success");
      })
      .catch((error) => {
        setError(error.response.data.error);

        setLoad(false);
      });
  };

  async function onClickFormSubmit(event) {
    event.preventDefault();
    const payload = new FormData();
    let files_ = {};
    let elementsToValidate;
    let { formData, currentError, error } = validateInputFields();

    if (id === AGENT_APPLICATION_ID && !userToken) {
      elementsToValidate = step === 1 ? mandateFields : unmandateFields;
    } else {
      elementsToValidate = form.elements;
    }

    // Track which element IDs have been validated for files
    const validatedFileIds = new Set();

    if (form.elements.length !== 0) {
      Array.from(elementsToValidate).forEach((ele) => {
        if (ele.type === "file") {
          validatedFileIds.add(ele.id);
          let file = document.getElementById(ele.id)?.files[0];
          if (file) {
            let extension = file.name.split(".").pop().toLowerCase();
            let ext = [];
            for (let key in ele.extensions) {
              if (ele.extensions[key]) {
                ext.push(key);
              }
            }
            let size = file.size <= parseInt(ele.properties.size) * 1024;
            if (!size) {
              currentError = `Your ${ele.properties.label} must not be larger than ${ele.properties.size} kb`;
              error.push({
                label: ele.properties.label,
                value: `Your ${ele.properties.label} must not be larger than ${ele.properties.size} kb`,
              });
            } else {
              if (ext.includes(extension)) {
                files_[ele.properties.label] = file;
              } else {
                currentError = `The image is in an unsupported extension '${extension}'.`;
                error.push({
                  label: ele.properties.label,
                  value: `The image is in an unsupported extension '${extension}'.`,
                });
              }
            }
          } else {
            const fieldName = ele.properties.label;
            if (
              (fieldName.toLowerCase().indexOf("video introduction") === -1 &&
                fieldName.toLowerCase().indexOf("resume upload") === -1 &&
                fieldName.toLowerCase().indexOf("profile photo") === -1) ||
              !userToken
            ) {
              if (
                ele.properties.required &&
                (ele.value === "" || ele.value === undefined)
              ) {
                currentError = `You must attach your ${ele.properties.label}`;
                error.push({
                  label: ele.properties.label,
                  value: `You must attach your ${ele.properties.label}`,
                });
              }
            }
          }
        }
      });
    }

    // Validate child file elements (e.g., supporting document upload)
    // These are conditionally rendered by parent select/radio components
    // and were filtered out of form.elements by filterChildElements(),
    // so the above loop never checks them.
    document.querySelectorAll(".form-view").forEach((input) => {
      try {
        const elementData = JSON.parse(input.getAttribute("data"));
        if (
          elementData &&
          elementData.type === "file" &&
          !validatedFileIds.has(elementData.id)
        ) {
          validatedFileIds.add(elementData.id);
          const fileInput = document.getElementById(elementData.id);
          const file = fileInput?.files?.[0];
          if (file) {
            let extension = file.name.split(".").pop().toLowerCase();
            let ext = [];
            for (let key in elementData.extensions) {
              if (elementData.extensions[key]) {
                ext.push(key);
              }
            }
            let size =
              file.size <= parseInt(elementData.properties.size) * 1024;
            if (!size) {
              currentError = `Your ${elementData.properties.label} must not be larger than ${elementData.properties.size} kb`;
              error.push({
                label: elementData.properties.label,
                value: `Your ${elementData.properties.label} must not be larger than ${elementData.properties.size} kb`,
              });
            } else {
              if (ext.includes(extension)) {
                files_[elementData.properties.label] = file;
              } else {
                currentError = `The file is in an unsupported extension '${extension}'.`;
                error.push({
                  label: elementData.properties.label,
                  value: `The file is in an unsupported extension '${extension}'.`,
                });
              }
            }
          } else {
            if (
              elementData.properties.required &&
              (elementData.properties.value === "" ||
                elementData.properties.value === undefined ||
                elementData.properties.value === null)
            ) {
              currentError = `You must attach your ${elementData.properties.label}`;
              error.push({
                label: elementData.properties.label,
                value: `You must attach your ${elementData.properties.label}`,
              });
            }
          }
        }
      } catch (e) {
        // Skip non-parseable elements
      }
    });
    if (id === AGENT_APPLICATION_ID && !userToken) {
      if (step === 1 && error.length === 0) {
        setErrorInputs([]);
      } else if (step === 2 && error.length === 0) {
        setErrorInputs([]);
      } else {
        const map = new Map();
        error.forEach((item) => {
          map.set(item.label, item);
        });
        const filtered = Array.from(map.values());
        setErrorInputs(filtered);
        setStep(step);
        return;
      }
    }

    if (currentError === "" && error.length === 0) {
      let hiddenFields = [];
      let formData_ = [];

      const flag = await swal({
        // title: "Are you sure?",
        // text: "Are you sure you want to submit this Form?",
        // icon: "warning",
        content: {
          element: "div",
          attributes: {
            innerHTML: `
              <p style="text-align:left;margin-bottom:0"><img src=${Img} /></p>
              <br>
              <h5 style="text-align:left">Job Application Disclaimer:</h5>
              <p style="text-align:left">
           By submitting your application, you consent to KocharTech collecting, processing, and retaining your personal information for recruitment purposes. Your details will be kept confidential and used only for evaluating your suitability for employment. We do not share or sell your data to third parties, except as required by law.
              </p>
              <p style="text-align:left">
            Your information may be stored for a reasonable period to support the recruitment process.
              </p>
              <p style="text-align:left">
            By proceeding, you confirm that all information provided is true and accurate to the best of your knowledge. Any false or misleading details may result in rejection of your application or termination of employment.
              </p>
              <p style="text-align:left">
               For queries, contact <a href="mailto:careers@kochartech.com">careers@kochartech.com</a>
              </p>
              <p>
              <strong>Thank you for choosing KocharTech.</strong>
              </p>
              <div class='row align-items-center justify-content-center'>
              <div class='col-md-3'>
              <img class='consent-logo' src=${IGZY} alt='igzy' />
              </div>
              <div class='col-md-3'>
              <img class='consent-logo' src=${KOCHARSOFT} alt='igzy' />
              </div>
              <div class='col-md-3'>
              <img class='consent-logo' src=${MAXICUS} alt='igzy' />
              </div>
              </div>           
            `,
          },
        },
        className: "custom-swal-container",
        buttons: {
          cancel: true,
          confirm: true,
        },
      });
      if (!flag) return;

      if (id === AGENT_APPLICATION_ID && !userToken) {
        if (step === 1) {
          if (name && email && decodedNum) {
            mandateFields?.forEach((element) => {
              if (
                typeof decodedNum == "string" ||
                typeof decodedSource == "string"
              ) {
                if (element.properties.label === "Phone Number") {
                  element.properties.value = decodedNum;
                  hiddenFields.push({
                    label: element.properties.label,
                    value: decodedNum,
                    element: element,
                  });
                } else if (element.properties.label === "Name") {
                  element.properties.value = name;
                  hiddenFields.push({
                    label: element.properties.label,
                    value: name,
                    element: element,
                  });
                } else if (element.properties.label === "Email") {
                  element.properties.value = email;
                  hiddenFields.push({
                    label: element.properties.label,
                    value: email,
                    element: element,
                  });
                }
              }
            });
          }
          formData_ = [...hiddenFields, ...formData];
        } else {
          formData_ = [...formData];
        }
      } else {
        formData_ = [...formData];
      }

      const files__ = { ...files_ };

      formData_ = formData_?.map((key) => {
        if (key.element.type === "capturephoto") {
          if (key.file) {
            payload.append(key.label, key.file);
          }
          const { file, ...rest } = key;
          return rest;
        }
        return key;
      });

      for (let key in files__) {
        payload.append(key, files__[key]);
      }

      payload.append("response", JSON.stringify(formData_));
      payload.append("form", id);
      payload.append("walkInType", walkInType);
      payload.append("utm_medium", utm_medium);
      payload.append("utm_campaign", utm_campaign);
      payload.append("utm_term", utm_term);
      payload.append("candidateId", candidateId);
      payload.append("formId", id);
      payload.append("client_name", client);
      // Successful form submission

      if (
        id === "63be60ffa416b72e38dc2f95" ||
        id === "63caa2a8d703dd1511734625" ||
        id === "66fead70fda16a001307f6c9" ||
        form.formType === "Feedback_Form"
      ) {
        finalFeedbackStatus(payload);
      } else {
        if (step === 1) {
          submitForm(payload);
        } else if (step === 2) {
          updateFormData(payload);
        } else {
          submitForm(payload);
        }
      }
    } else {
      const map = new Map();
      error.forEach((item) => {
        map.set(item.label, item);
      });
      const filtered = Array.from(map.values());
      setErrorInputs(filtered);
    }
  }

  async function checkAuthentication() {
    if (decodedNum) {
      await axios
        .get(
          `/OTPAutentication/isMobileNoVerified/${decodedNum.trim()}/form/${id}`
        )
        .then((res) => {
          const data = res.data.OTPStatus;
          setOtpStatus(data);
          return res;
        })
        .catch((err) => {
          const data = err.response.data.OTPStatus;
          setOtpStatus(data);
          console.log("Error", err, err.response);
          return err;
        });
    }
  }

  const renderFormElements = (elements, errorInputs) =>
    elements.map((element, key) => {
      if (typeof decodedNum === "string" || typeof decodedSource === "string") {
        switch (element.properties.label) {
          case "Phone Number":
            element.properties.value = decodedNum;
            if (id === AGENT_APPLICATION_ID && !userToken) {
              return <></>;
            }
            break;
          case "Name":
            element.properties.value = name;
            if (id === AGENT_APPLICATION_ID && !userToken) {
              return <></>;
            }
            break;
          case "Email":
            element.properties.value = email;
            if (id === AGENT_APPLICATION_ID && !userToken) {
              return <></>;
            }
            break;
          case "Employee Referal ID":
            element.properties.value = referalCode;
            break;
          case "How did you come to know about us":
            element.properties.value =
              decodedSource === "QRcode" || decodedSource === "null"
                ? ""
                : decodedSource;
            break;
          case "Select Consultancy Name":
            element.properties.value = consultancyName || "";
            break;
          default:
            break;
        }
      }
      if (
        (element.type === "file" || element.type === "capturephoto") &&
        userToken
      ) {
        const fieldName = element.properties.label;
        if (
          fieldName.toLowerCase().indexOf("video introduction") === 0 ||
          fieldName.toLowerCase().indexOf("resume upload") === 0 ||
          fieldName.toLowerCase().indexOf("profile photo") === 0
        ) {
          element.isMandate = false;
        }
      }
      element.editable = true;
      return (
        <GetFormComponent
          element={element}
          key={key}
          formId={id}
          departments={departments}
          errorInputs={errorInputs}
          tokenType={userToken ? "user.token" : "candidate.token"}
        />
      );
    });

  return (
    <div>
      {!isConsultant() && (
        <div className="container-fluid p-0">
          {load && (
            <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
          )}
          <NavbarApplication />
          <div className="application-form">
            <div className="row bg-image">
              <div className="col-md-7">
                <div
                  className="p-4 bg-white form-wrap shadow"
                  style={{
                    ...(window.location.hostname === DOMAIN && {
                      borderTop: "14px solid rgb(26, 180, 216)",
                    }),
                  }}
                >
                  <div className="custom-skeleton">
                    <Skeleton
                      active
                      loading={isLoading}
                      paragraph={{
                        rows: 13,
                      }}
                    >
                      {otpStatus === "User Authorized" ? (
                        <div>
                          <h1 className="candidate-form-title">{form.name}</h1>
                          {/* <p className="candidate-form-description">
                            {form.trf.overview}
                            </p> */}
                          <hr />

                          {id === AGENT_APPLICATION_ID && !userToken ? (
                            <>
                              <div className="mt-2 row" id="candidateForm">
                                {step === 1 && (
                                  <>
                                    <div className="form-group col-12 row">
                                      <p className="col-sm-4">
                                        <strong>Name:</strong> {name}
                                      </p>
                                      <p className="col-sm-4">
                                        <strong>Mobile Number:</strong>{" "}
                                        {decodedNum}
                                      </p>
                                      <p className="col-sm-4">
                                        <strong>Email:</strong> {email}
                                      </p>
                                    </div>
                                    {renderFormElements(
                                      mandateFields,
                                      errorInputs
                                    )}
                                  </>
                                )}
                                {step === 2 && (
                                  <div className="col-12 form-group">
                                    <h4 className="pl-2 ">
                                      Your application has been successfully
                                      submitted.
                                    </h4>
                                    <p className="pl-2">
                                      Would you like to take a few more seconds
                                      to fill in some additional details? This
                                      will help us better match you with
                                      exciting future opportunities and enhance
                                      your profile!
                                    </p>
                                    <div className="divider">
                                      <hr
                                        className="mb-4"
                                        style={{ opacity: "1 !important" }}
                                      />
                                    </div>
                                    {renderFormElements(
                                      unmandateFields,
                                      errorInputs
                                    )}
                                  </div>
                                )}
                              </div>
                            </>
                          ) : (
                            <>
                              {renderFormElements(form.elements, errorInputs)}
                            </>
                          )}
                          <div>
                            <If test={error !== ""}>
                              <div className="alert alert-danger">{error}</div>
                            </If>
                            {id === AGENT_APPLICATION_ID && !userToken ? (
                              <CceFormSubmitButton
                                step={step}
                                onClickFormSubmit={onClickFormSubmit}
                                agreed={agreed}
                                setAgreed={setAgreed}
                              />
                            ) : (
                              <OtherSubmitButton
                                onClickFormSubmit={onClickFormSubmit}
                                agreed={agreed}
                                setAgreed={setAgreed}
                              />
                            )}
                          </div>
                        </div>
                      ) : (
                        <h1>Unauthorized User</h1>
                      )}
                    </Skeleton>
                  </div>
                </div>
              </div>
              <div className="col-md-5" />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ApplicationView;
